import { FindingDiffStatus, IEvidenceChange, IFinding, IInspection, IInspectionDiff, ITarget, Lens, ProductLine, Severity } from "./raio-x.types";

export interface IFilters { lens: Lens | null; severity: Severity | null; onlyNew: boolean }
export const EMPTY_FILTERS: IFilters = { lens: null, severity: null, onlyNew: false };

export interface IProductGroup { product: ProductLine; groups: ITarget[]; workspaces: ITarget[] }
export interface IGrouped { organization: ITarget | null; products: IProductGroup[] }

const PRODUCT_ORDER: ProductLine[] = ["HEALTH", "DENTAL", "LIFE"];

export function groupBySection(inspection: IInspection): IGrouped {
  const organization = inspection.targets.find((t) => t.targetType === "ORGANIZATION") ?? null;
  const products = PRODUCT_ORDER.map((product) => ({
    product,
    groups: inspection.targets.filter((t) => t.targetType === "ADDRESSABLE_GROUP" && t.productLine === product),
    workspaces: inspection.targets.filter((t) => t.targetType === "WORKSPACE" && t.productLine === product),
  })).filter((p) => p.groups.length > 0 || p.workspaces.length > 0);
  return { organization, products };
}

export function diffStatusMap(diff: IInspectionDiff): Map<string, FindingDiffStatus> {
  return new Map(diff.findings.map((f) => [f.fingerprint, f.status]));
}

/** why: mudança de evidência (ex.: 1 de 14 cargos) por fingerprint; usado pelo Task 2 para não confundir "persiste" com "imutável". */
export function evidenceChangeMap(diff: IInspectionDiff): Map<string, IEvidenceChange> {
  return new Map(diff.evidenceChanges.map((c) => [c.fingerprint, c]));
}

export function applyFilters(findings: IFinding[], filters: IFilters, status: Map<string, FindingDiffStatus>): IFinding[] {
  return findings.filter((f) => {
    if (filters.lens && f.lens !== filters.lens) return false;
    if (filters.severity && f.severity !== filters.severity) return false;
    if (filters.onlyNew && status.get(f.fingerprint) !== "NEW") return false;
    return true;
  });
}

export function countBySeverity(findings: IFinding[]): Record<Severity, number> & { descriptive: number } {
  const out = { BLOCKER: 0, MAJOR: 0, MINOR: 0, descriptive: 0 };
  findings.forEach((f) => {
    if (f.nature === "DESCRIPTIVE" || !f.severity) out.descriptive += 1;
    else out[f.severity] += 1;
  });
  return out;
}
